import { RiMessageLine } from "react-icons/ri";
import { IoMdCheckboxOutline } from "react-icons/io";
import { PiNotePencil } from "react-icons/pi";
import DashboardHome from "../screens/Dashboard/DashboardHome";
import DashboardVendor from "../screens/Dashboard/DashboardVendor";
import DashboardUsers from "../screens/Dashboard/DashboardUsers";
import DashboardService from "../screens/Dashboard/DashboardService";
import { VscTools } from "react-icons/vsc";
import { RxDashboard } from "react-icons/rx";
import CreatOffers from "../screens/Dashboard/ServicesNestedPages/CreatOffers";
import AddVendor from "../screens/Dashboard/VendorNestedPage/AddVendor";
import VendorProfile from "../screens/Dashboard/VendorNestedPage/VendorProfile";
import AddUsers from "../screens/Dashboard/UsersNestedPages/AddUser";
import EditUser from "../screens/Dashboard/UsersNestedPages/EditUser";
import UsersProfile from "../screens/Dashboard/UsersNestedPages/UsersProfile";
import ChatScreen from "../screens/Dashboard/MessagesNestedPages/ChatScreen";
import ChatList from "../screens/Dashboard/DashboardMessage";
import DashboardServiceMain from "../screens/Dashboard/DashboardServiceMain";
import EditService from "../screens/Dashboard/ServicesNestedPages/EditService";
import { MdOutlineWork } from "react-icons/md";
import DashboardUserJobs from "../screens/Dashboard/DashboardUserJobs";
import OrderDetails from "../screens/Dashboard/UserJobsNestedPages/OrderDetails";
import EditOrderDetail from "../screens/Dashboard/UserJobsNestedPages/EditOrderDetail";
import CreateJob from "../screens/Dashboard/CreateJob";
import ChargeCustomer from "../screens/Dashboard/ChargeCustomer";
import CouponDetails from "../screens/Dashboard/CouponNestedPages/CouponDetail";
import AddCoupon from "../screens/Dashboard/CouponNestedPages/AddCoupon";
import { MdLocalOffer, MdAttachMoney, MdNotes, MdCardMembership, MdSettings, MdNotifications, MdSupportAgent, MdAnalytics, MdDescription } from "react-icons/md";
import DashboardCoupons from "../screens/Dashboard/DashboardCoupon";
import DashboardNotes from "../screens/Dashboard/DashboardNotes";
import DashboardSubscriptions from "../screens/Dashboard/DashboardSubscriptions";
import DashboardReports from "../screens/Dashboard/DashboardReports";
import DashboardAppSettings from "../screens/Dashboard/DashboardAppSettings";
import DashboardAnalytics from "../screens/Dashboard/DashboardAnalytics";
import DashboardSupport from "../screens/Dashboard/DashboardSupport";
import DashboardNotifications from "../screens/Dashboard/DashboardNotifications";
import DashboardProContracts from "../screens/Dashboard/DashboardProContracts";
import DashboardEmail from "../screens/Dashboard/DashboardEmail";
import PasswordGate from "../component/common/PasswordGate/PasswordGate";
import { MdEmail } from "react-icons/md";

const GATE_PASSWORD = "done2026";
const gated = (key, node) => (
  <PasswordGate gateKey={key} expected={GATE_PASSWORD} hint="Ask your admin if you don't know the password.">
    {node}
  </PasswordGate>
);

export const logoutPage = () => {
  return;
};

// Manager role only sees: Dashboard, Users, Coupons, Notes, Messages, Orders, Charge Customer
const MANAGER_PAGES = ["Dashboard", "Users", "Coupons", "Notes", "Messages", "Orders", "Charge Customer"];

export const getFilteredRoutes = (role) => {
  if (role === "manager") {
    return userDashboardRoutes.map((route) => ({
      ...route,
      list_in_sidebar: route.list_in_sidebar && MANAGER_PAGES.includes(route.caption),
    }));
  }
  return userDashboardRoutes;
};
export const userDashboardRoutes = [
  {
    caption: "Dashboard",
    linkTo: "/",
    icon: <RxDashboard />,
    element: <DashboardHome />,
    list_in_sidebar: true,
    both: false,
    admin: true,
    user: false,
  },
  {
    caption: "Pros",
    linkTo: "/vendor",
    icon: <PiNotePencil />,
    element: gated("admin_pros_gate", <DashboardVendor />),
    list_in_sidebar: true,
    both: true,
    admin: true,
    user: true,
  },
  {
    caption: "AddVendor",
    linkTo: "/vendor/add-vendor",
    icon: <PiNotePencil />,
    element: gated("admin_pros_gate", <AddVendor />),
    list_in_sidebar: false,
    both: true,
    admin: true,
    user: true,
  },
  {
    caption: "Edit Pro",
    linkTo: "/vendor/edit-vendor/:id",
    icon: <PiNotePencil />,
    element: gated("admin_pros_gate", <AddVendor />),
    list_in_sidebar: false, // 👈 Hides it from sidebar
    both: true,
    admin: true,
    user: true,
  },
  {
    caption: "Pro Profile",
    linkTo: "/vendor/vendor-profile/:id",
    icon: <PiNotePencil />,
    element: gated("admin_pros_gate", <VendorProfile />),
    list_in_sidebar: false,
    both: true,
    admin: true,
    user: true,
  },
  {
    caption: "Provider Agreements",
    linkTo: "/pro-contracts",
    icon: <MdDescription />,
    element: gated("admin_pros_gate", <DashboardProContracts />),
    list_in_sidebar: true,
    both: false,
    admin: true,
    user: false,
  },
  {
    caption: "Email",
    linkTo: "/email",
    icon: <MdEmail />,
    element: gated("admin_email_gate", <DashboardEmail />),
    list_in_sidebar: true,
    both: false,
    admin: true,
    user: false,
  },
  {
    caption: "Add Users",
    linkTo: "/users/add-users",
    icon: <PiNotePencil />,
    element: <AddUsers />,
    list_in_sidebar: false,
    both: true,
    admin: true,
    user: true,
  },

  {
    caption: "Users",
    linkTo: "/users",
    icon: <IoMdCheckboxOutline />,
    element: <DashboardUsers />,
    list_in_sidebar: true,
    both: true,
    admin: true,
    user: true,
  },
  {
    caption: "Edit User",
    linkTo: "/users/edit-user/:id",
    icon: <PiNotePencil />,
    element: <EditUser />,
    list_in_sidebar: false,
    both: true,
    admin: true,
    user: true,
  },
  {
    caption: "User Profile",
    linkTo: "/users/user-profile/:id",
    icon: <PiNotePencil />,
    element: <UsersProfile />,
    list_in_sidebar: false,
    both: true,
    admin: true,
    user: true,
  },
  // {
  //   caption: "Users Profile",
  //   linkTo: "/users-profile",
  //   icon: <IoMdCheckboxOutline />,
  //   element: <UsersProfile />,
  //   list_in_sidebar: false,
  //   both: true,
  //   admin: true,
  //   user: true,
  // },
  {
    caption: "Services",
    linkTo: "/service-main/add-services",
    icon: <VscTools />,
    element: gated("admin_services_gate", <DashboardService />),
    list_in_sidebar: false,
    both: true,
    admin: true,
    user: true,
  },
  {
    caption: "Edit Service",
    linkTo: "/service-main/edit-service/:id",
    icon: <VscTools />,
    element: gated("admin_services_gate", <EditService />),
    list_in_sidebar: false,
    both: true,
    admin: true,
    user: true,
  },
  {
    caption: "Services",
    linkTo: "/service-main",
    icon: <VscTools />,
    element: gated("admin_services_gate", <DashboardServiceMain />),
    list_in_sidebar: true,
    both: true,
    admin: true,
    user: true,
  },
  {
    caption: "Coupons",
    linkTo: "/coupons",
    icon: <MdLocalOffer />,
    element: <DashboardCoupons />,
    list_in_sidebar: true,
    both: false,
    admin: true,
    user: false, // Only admin can manage coupons
  },
  {
    caption: "Add Coupon",
    linkTo: "/coupons/add-coupon",
    icon: <MdLocalOffer />,
    element: <AddCoupon />,
    list_in_sidebar: false,
    both: false,
    admin: true,
    user: false,
  },
  {
    caption: "Edit Coupon",
    linkTo: "/coupons/edit-coupon/:id",
    icon: <MdLocalOffer />,
    element: <AddCoupon />,
    list_in_sidebar: false,
    both: false,
    admin: true,
    user: false,
  },
  {
    caption: "Coupon Details",
    linkTo: "/coupons/coupon-details/:id",
    icon: <MdLocalOffer />,
    element: <CouponDetails />,
    list_in_sidebar: false,
    both: false,
    admin: true,
    user: false,
  },
  {
    caption: "Notes",
    linkTo: "/notes",
    icon: <MdNotes />,
    element: <DashboardNotes />,
    list_in_sidebar: true,
    both: false,
    admin: true,
    user: false,
  },
  {
    caption: "Chat Screen",
    linkTo: "/message/chat-screen",
    icon: <RiMessageLine />,
    element: <ChatScreen />,
    list_in_sidebar: false,
    both: true,
    admin: true,
    user: true,
  },
  {
    caption: "Messages",
    linkTo: "/message",
    icon: <RiMessageLine />,
    element: <ChatList />,
    list_in_sidebar: true,
    both: true,
    admin: true,
    user: true,
  },
  {
    caption: "Orders",
    linkTo: "/orders",
    icon: <MdOutlineWork />,
    element: <DashboardUserJobs />,
    list_in_sidebar: true,
    both: true,
    admin: true,
    user: true,
  },
  {
    caption: "Subscriptions",
    linkTo: "/subscriptions",
    icon: <MdCardMembership />,
    element: <DashboardSubscriptions />,
    list_in_sidebar: true,
    both: false,
    admin: true,
    user: false,
  },
  {
    caption: "Orders",
    linkTo: "/orders/order-detail/:id",
    icon: <MdOutlineWork />,
    element: <OrderDetails />,
    list_in_sidebar: false,
    both: true,
    admin: true,
    user: true,
  },
  {
    caption: "Orders",
    linkTo: "/orders/edit-order/:id",
    icon: <MdOutlineWork />,
    element: <EditOrderDetail />,
    list_in_sidebar: false,
    both: true,
    admin: true,
    user: true,
  },
  {
    caption: "Create Job",
    linkTo: "/orders/create-job",
    icon: <MdOutlineWork />,
    element: <CreateJob />,
    list_in_sidebar: false,
    both: false,
    admin: true,
    user: false,
  },
  {
    caption: "Charge Customer",
    linkTo: "/charge-customer",
    icon: <MdAttachMoney />,
    element: <ChargeCustomer />,
    list_in_sidebar: true,
    both: false,
    admin: true,
    user: false,
  },
  {
    caption: "Reports",
    linkTo: "/reports",
    icon: <MdDescription />,
    element: <DashboardReports />,
    list_in_sidebar: true,
    both: false,
    admin: true,
    user: false,
  },
  {
    caption: "Analytics",
    linkTo: "/analytics",
    icon: <MdAnalytics />,
    element: <DashboardAnalytics />,
    list_in_sidebar: true,
    both: false,
    admin: true,
    user: false,
  },
  {
    caption: "Support",
    linkTo: "/support",
    icon: <MdSupportAgent />,
    element: <DashboardSupport />,
    list_in_sidebar: true,
    both: false,
    admin: true,
    user: false,
  },
  {
    caption: "Notifications",
    linkTo: "/notifications",
    icon: <MdNotifications />,
    element: <DashboardNotifications />,
    list_in_sidebar: true,
    both: false,
    admin: true,
    user: false,
  },
  {
    caption: "Settings",
    linkTo: "/app-settings",
    icon: <MdSettings />,
    element: <DashboardAppSettings />,
    list_in_sidebar: true,
    both: false,
    admin: true,
    user: false,
  },
  {
    caption: "Create Offers",
    linkTo: "/create-offers/:id",
    icon: <RiMessageLine />,
    element: <CreatOffers />,
    list_in_sidebar: false,
    both: true,
    admin: true,
    user: true,
  },
  // {
  //   caption: "Settings",
  //   linkTo: "/settings",
  //   icon: <IoSettingsOutline />,
  //   element: <DashboardSettings />,
  //   list_in_sidebar: true,
  //   both: true,
  //   admin: true,
  //   user: true,
  // },
];
